import React from 'react';
import { Download, FileText, Shield, Calendar, TrendingUp, Bell, DollarSign } from 'lucide-react';

const TrainerResourcesManager: React.FC = () => {

  const downloadConsultationForm = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Client Consultation Form</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">CLIENT CONSULTATION FORM</h1>
      
      <h3>Personal Information:</h3>
      <p>Name: _________________________________ Date: ___________</p>
      <p>Age: _____ Gender: _____ Phone: _________________________</p>
      <p>Email: ____________________________________________</p>
      <p>Emergency Contact: __________________________________</p>
      <p>Emergency Phone: ___________________________________</p>
      
      <h3>Health History:</h3>
      <p>Do you have any medical conditions? ☐ Yes ☐ No</p>
      <p>If yes, please describe: ______________________________</p>
      <p>________________________________________________</p>
      <br>
      <p>Are you currently taking any medications? ☐ Yes ☐ No</p>
      <p>If yes, please list: _________________________________</p>
      <p>________________________________________________</p>
      <br>
      <p>Have you had any injuries in the past 12 months? ☐ Yes ☐ No</p>
      <p>If yes, please describe: ______________________________</p>
      <p>________________________________________________</p>
      <br>
      <p>Do you have any physical limitations? ☐ Yes ☐ No</p>
      <p>If yes, please describe: ______________________________</p>
      <p>________________________________________________</p>
      
      <h3>Fitness History:</h3>
      <p>Current activity level: ☐ Sedentary ☐ Light ☐ Moderate ☐ Active</p>
      <p>How many days per week do you currently exercise? _______</p>
      <p>What types of exercise do you enjoy? ____________________</p>
      <p>________________________________________________</p>
      
      <h3>Goals:</h3>
      <p>Primary fitness goal: ________________________________</p>
      <p>Secondary goals: ___________________________________</p>
      <p>Target timeline: ___________________________________</p>
      
      <h3>Lifestyle:</h3>
      <p>Occupation: _____________________________________</p>
      <p>Average hours of sleep per night: ___________________</p>
      <p>Stress level (1-10): ______________________________</p>
      
      <br><br>
      <p>Client Signature: _________________________ Date: _______</p>
      <p>Trainer Signature: ________________________ Date: _______</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Client_Consultation_Form.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadWorkoutPlan = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Weekly Workout Plan</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">WEEKLY WORKOUT PLAN</h1>
      
      <p><strong>Client:</strong> _________________________ <strong>Week of:</strong> _______________</p>
      <br>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px; background-color: #f0f0f0;"><strong>MONDAY</strong> - _________________</td>
        </tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px; background-color: #f0f0f0;"><strong>TUESDAY</strong> - _________________</td>
        </tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
      </table>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px; background-color: #f0f0f0;"><strong>WEDNESDAY</strong> - _________________</td>
        </tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
      </table>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px; background-color: #f0f0f0;"><strong>THURSDAY</strong> - _________________</td>
        </tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
      </table>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px; background-color: #f0f0f0;"><strong>FRIDAY</strong> - _________________</td>
        </tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
      </table>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px; background-color: #f0f0f0;"><strong>SATURDAY</strong> - _________________</td>
        </tr>
      </table>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
        <tr><td style="padding: 8px;">________________________</td><td style="padding: 8px;">____</td><td style="padding: 8px;">____</td><td style="padding: 8px;">______</td><td style="padding: 8px;">__________</td></tr>
      </table>
      
      
      
      <h3>WEEKLY NOTES:</h3>
      <p>________________________________________________</p>
      <p>________________________________________________</p>
      <p>________________________________________________</p>
      
      <h3>NEXT WEEK'S FOCUS:</h3>
      <p>________________________________________________</p>
      <p>________________________________________________</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Weekly_Workout_Plan.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadLiabilityWaiver = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Liability Waiver and Assumption of Risk</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">LIABILITY WAIVER AND ASSUMPTION OF RISK</h1>
      
      <p style="text-align: center; font-weight: bold; color: red;">IMPORTANT: READ CAREFULLY BEFORE SIGNING</p>
      
      <p><strong>Client Name:</strong> _________________________________________</p>
      <p><strong>Date:</strong> _______________________________________________</p>
      <br>
      
      <h3>ASSUMPTION OF RISK</h3>
      <p>I understand and acknowledge that participation in fitness activities involves inherent risks including, but not limited to, the risk of personal injury, property damage, and even death.</p>
      
      <p>I voluntarily assume all risks associated with participation in fitness training, including risks that may arise from:</p>
      <ul>
        <li>Use of equipment</li>
        <li>Physical exertion beyond my fitness level</li>
        <li>Failure to follow instructions</li>
        <li>Actions of other participants</li>
        <li>Condition of facilities or equipment</li>
      </ul>
      
      <h3>RELEASE AND WAIVER OF LIABILITY</h3>
      <p>In consideration for being allowed to participate in fitness training activities, I hereby release, waive, discharge, and hold harmless the trainer and their business from any and all liability, claims, demands, or causes of action arising from my participation.</p>
      
      <h3>MEDICAL CLEARANCE</h3>
      <p>I certify that I am in good physical condition and have no medical conditions that would prevent safe participation in exercise activities. I have consulted with a physician regarding my ability to participate in physical exercise.</p>
      
      <h3>INDEMNIFICATION</h3>
      <p>I agree to indemnify and hold harmless the trainer from any loss, liability, damage, or costs that may arise from my participation in training activities.</p>
      
      <h3>ACKNOWLEDGMENT</h3>
      <p>I have read this waiver, understand its contents, and sign it voluntarily. I understand this is a release of liability and a contract between myself and the trainer.</p>
      
      <br><br>
      <p><strong>Client Signature:</strong> _________________________ <strong>Date:</strong> _______</p>
      <br>
      <p><strong>Printed Name:</strong> ___________________________________</p>
      <br>
      <p><strong>Witness Signature:</strong> _______________________ <strong>Date:</strong> _______</p>
      <br>
      <p><strong>Witness Printed Name:</strong> ____________________________</p>
      
      <br><br>
      <h3>TRAINER USE ONLY:</h3>
      <p><strong>Trainer Name:</strong> ___________________________________</p>
      <p><strong>Trainer Signature:</strong> ______________________ <strong>Date:</strong> _______</p>
      
      <br><br>
      <p style="color: red; font-weight: bold;">DISCLAIMER: This is a sample form only. Consult with a qualified attorney in your jurisdiction before using any liability waiver.</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Liability_Waiver.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadNutritionGuide = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Basic Nutrition Guidelines</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">BASIC NUTRITION GUIDELINES</h1>
      
      <h3>GENERAL PRINCIPLES:</h3>
      <ul>
        <li>Eat a variety of foods from all food groups</li>
        <li>Focus on whole, unprocessed foods</li>
        <li>Stay adequately hydrated throughout the day</li>
        <li>Practice portion control</li>
        <li>Eat regular, balanced meals</li>
      </ul>
      
      <h3>MACRONUTRIENTS:</h3>
      
      <h4 style="color: #2563eb;">PROTEINS (20-30% of daily calories):</h4>
      <ul>
        <li>Lean meats, fish, poultry</li>
        <li>Eggs and dairy products</li>
        <li>Legumes, nuts, and seeds</li>
        <li>Aim for protein at each meal</li>
      </ul>
      
      <h4 style="color: #16a34a;">CARBOHYDRATES (45-65% of daily calories):</h4>
      <ul>
        <li>Whole grains (brown rice, quinoa, oats)</li>
        <li>Fruits and vegetables</li>
        <li>Legumes</li>
        <li>Choose complex carbs over simple sugars</li>
      </ul>
      
      <h4 style="color: #ea580c;">FATS (20-35% of daily calories):</h4>
      <ul>
        <li>Avocados, nuts, and olive oil</li>
        <li>Fatty fish (salmon, sardines)</li>
        <li>Seeds (chia, flax, hemp)</li>
        <li>Limit saturated and avoid trans fats</li>
      </ul>
      
      <h3>HYDRATION:</h3>
      <ul>
        <li>Aim for 8-10 glasses of water daily</li>
        <li>Increase intake during exercise</li>
        <li>Monitor urine color for hydration status</li>
        <li>Limit sugary drinks and alcohol</li>
      </ul>
      
      <h3>MEAL TIMING:</h3>
      <ul>
        <li>Eat every 3-4 hours to maintain energy</li>
        <li>Have a balanced breakfast within 1-2 hours of waking</li>
        <li>Pre-workout: Light carbs 30-60 minutes before</li>
        <li>Post-workout: Protein and carbs within 30 minutes</li>
      </ul>
      
      <h3>PORTION CONTROL GUIDE:</h3>
      <ul>
        <li>Protein: Palm-sized portion</li>
        <li>Carbs: Cupped hand portion</li>
        <li>Fats: Thumb-sized portion</li>
        <li>Vegetables: 2 cupped hands</li>
      </ul>
      
      <table style="width: 100%; border-collapse: collapse; margin: 20px 0;" border="1">
        <tr>
          <th style="padding: 10px; background-color: #16a34a; color: white;">FOODS TO EMPHASIZE</th>
          <th style="padding: 10px; background-color: #dc2626; color: white;">FOODS TO LIMIT</th>
        </tr>
        <tr>
          <td style="padding: 10px;">• Colorful fruits and vegetables<br>• Lean proteins<br>• Whole grains<br>• Healthy fats<br>• Water</td>
          <td style="padding: 10px;">• Processed and packaged foods<br>• Added sugars<br>• Excess sodium<br>• Saturated fats<br>• Alcohol</td>
        </tr>
      </table>
      
      <h3>HEALTHY HABITS:</h3>
      <ul>
        <li>✓ Plan and prepare meals in advance</li>
        <li>✓ Read nutrition labels</li>
        <li>✓ Keep a food diary</li>
        <li>✓ Eat mindfully without distractions</li>
        <li>✓ Listen to hunger and fullness cues</li>
      </ul>
      
      <br>
      <p style="font-style: italic; color: #666;">Note: These are general guidelines. Individual needs may vary based on health conditions, goals, and activity level. Consult with a registered dietitian for personalized advice.</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Nutrition_Guidelines.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadProgressSheet = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Client Progress Tracking Sheet</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">CLIENT PROGRESS TRACKING SHEET</h1>
      
      <p><strong>Client:</strong> _________________________ <strong>Start Date:</strong> ___________</p>
      
      <h3>INITIAL MEASUREMENTS:</h3>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Date:</strong> ___________</td>
          <td style="padding: 8px;"><strong>Weight:</strong> ___________</td>
          <td style="padding: 8px;"><strong>Height:</strong> ___________</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Body Fat %:</strong> _______</td>
          <td style="padding: 8px;"><strong>Muscle Mass:</strong> _________</td>
          <td style="padding: 8px;"></td>
        </tr>
      </table>
      
      <h3>CIRCUMFERENCE MEASUREMENTS:</h3>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Chest:</strong> _______</td>
          <td style="padding: 8px;"><strong>Waist:</strong> _______</td>
          <td style="padding: 8px;"><strong>Hips:</strong> _______</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Arms:</strong> _______</td>
          <td style="padding: 8px;"><strong>Thighs:</strong> _______</td>
          <td style="padding: 8px;"><strong>Neck:</strong> _______</td>
        </tr>
      </table>
      
      <h3>FITNESS ASSESSMENTS:</h3>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Push-ups (max):</strong> _______</td>
          <td style="padding: 8px;"><strong>Sit-ups (1 min):</strong> _______</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Plank Hold:</strong> _________</td>
          <td style="padding: 8px;"><strong>Mile Time:</strong> ___________</td>
        </tr>
      </table>
      
      <h3>MONTHLY PROGRESS:</h3>
      
      <h4 style="background-color: #f0f8ff; padding: 10px;">MONTH 1</h4>
      <p><strong>Date:</strong> ___________</p>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Weight:</strong> ___________</td>
          <td style="padding: 8px;"><strong>Body Fat %:</strong> ___________</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Chest:</strong> _______</td>
          <td style="padding: 8px;"><strong>Waist:</strong> _______</td>
        </tr>
      </table>
      <p><strong>Key Achievements:</strong> _______________________________</p>
      <p>___________________________________________</p>
      
      <h4 style="background-color: #f0f8ff; padding: 10px;">MONTH 2</h4>
      <p><strong>Date:</strong> ___________</p>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Weight:</strong> ___________</td>
          <td style="padding: 8px;"><strong>Body Fat %:</strong> ___________</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Chest:</strong> _______</td>
          <td style="padding: 8px;"><strong>Waist:</strong> _______</td>
        </tr>
      </table>
      <p><strong>Key Achievements:</strong> _______________________________</p>
      <p>___________________________________________</p>
      
      <h4 style="background-color: #f0f8ff; padding: 10px;">MONTH 3</h4>
      <p><strong>Date:</strong> ___________</p>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Weight:</strong> ___________</td>
          <td style="padding: 8px;"><strong>Body Fat %:</strong> ___________</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Chest:</strong> _______</td>
          <td style="padding: 8px;"><strong>Waist:</strong> _______</td>
        </tr>
      </table>
      <p><strong>Key Achievements:</strong> _______________________________</p>
      <p>___________________________________________</p>
      
      <h3>STRENGTH PROGRESS:</h3>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Starting Weight</th>
          <th style="padding: 8px;">Current Weight</th>
          <th style="padding: 8px;">Starting Reps</th>
          <th style="padding: 8px;">Current Reps</th>
        </tr>
        <tr>
          <td style="padding: 8px;">______________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">______</td>
          <td style="padding: 8px;">_______</td>
        </tr>
        <tr>
          <td style="padding: 8px;">______________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">______</td>
          <td style="padding: 8px;">_______</td>
        </tr>
        <tr>
          <td style="padding: 8px;">______________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">______</td>
          <td style="padding: 8px;">_______</td>
        </tr>
      </table>
      
      <h3>GOAL TRACKING:</h3>
      <p><strong>Primary Goal:</strong> ________________________________</p>
      <p><strong>Target Date:</strong> ________________________________</p>
      <p><strong>Progress Status:</strong> ____________________________</p>
      <br>
      <p><strong>Secondary Goal:</strong> _____________________________</p>
      <p><strong>Target Date:</strong> ________________________________</p>
      <p><strong>Progress Status:</strong> ____________________________</p>
      
      <h3>PHOTO PROGRESS:</h3>
      <p>☐ Front view photos taken</p>
      <p>☐ Side view photos taken</p>
      <p>☐ Back view photos taken</p>
      <p><strong>Photo dates:</strong> ______________________________</p>
      
      <h3>NOTES AND OBSERVATIONS:</h3>
      <p>___________________________________________</p>
      <p>___________________________________________</p>
      <p>___________________________________________</p>
      <p>___________________________________________</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Progress_Tracking_Sheet.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadEmergencyForm = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Emergency Contact Information Form</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">EMERGENCY CONTACT INFORMATION FORM</h1>
      
      <h3 style="background-color: #fee2e2; padding: 10px; color: #dc2626;">CLIENT INFORMATION:</h3>
      <p><strong>Name:</strong> __________________________________________</p>
      <p><strong>Date of Birth:</strong> _________________________________</p>
      <p><strong>Phone:</strong> ________________________________________</p>
      <p><strong>Address:</strong> ______________________________________</p>
      <p>_______________________________________________</p>
      
      <h3 style="background-color: #dbeafe; padding: 10px; color: #1e40af;">PRIMARY EMERGENCY CONTACT:</h3>
      <p><strong>Name:</strong> __________________________________________</p>
      <p><strong>Relationship:</strong> _________________________________</p>
      <p><strong>Phone (Primary):</strong> ______________________________</p>
      <p><strong>Phone (Secondary):</strong> ____________________________</p>
      <p><strong>Address:</strong> ______________________________________</p>
      <p>_______________________________________________</p>
      
      <h3 style="background-color: #dcfce7; padding: 10px; color: #15803d;">SECONDARY EMERGENCY CONTACT:</h3>
      <p><strong>Name:</strong> __________________________________________</p>
      <p><strong>Relationship:</strong> _________________________________</p>
      <p><strong>Phone:</strong> ________________________________________</p>
      
      <h3 style="background-color: #fef3c7; padding: 10px; color: #92400e;">MEDICAL INFORMATION:</h3>
      <p><strong>Primary Care Physician:</strong> _______________________</p>
      <p><strong>Physician Phone:</strong> ______________________________</p>
      <br>
      <p><strong>Medical Conditions:</strong> ___________________________</p>
      <p>_______________________________________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Allergies:</strong> ___________________________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Current Medications:</strong> __________________________</p>
      <p>_______________________________________________</p>
      <p>_______________________________________________</p>
      
      <h3 style="background-color: #e0e7ff; padding: 10px; color: #3730a3;">INSURANCE INFORMATION:</h3>
      <p><strong>Insurance Company:</strong> ____________________________</p>
      <p><strong>Policy Number:</strong> ________________________________</p>
      <p><strong>Group Number:</strong> _________________________________</p>
      
      <h3 style="background-color: #f3e8ff; padding: 10px; color: #7c3aed;">PREFERRED MEDICAL FACILITIES:</h3>
      <p><strong>Preferred Hospital:</strong> ___________________________</p>
      <p><strong>Address:</strong> ______________________________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Preferred Urgent Care:</strong> _______________________</p>
      <p><strong>Address:</strong> ______________________________________</p>
      <p>_______________________________________________</p>
      
      <h3>SPECIAL INSTRUCTIONS:</h3>
      <p>_______________________________________________</p>
      <p>_______________________________________________</p>
      <p>_______________________________________________</p>
      
      <br><br>
      <p style="border: 2px solid #000; padding: 10px; background-color: #f9f9f9;">
        <strong>I authorize my trainer to contact the above individuals and share this information with emergency medical personnel if necessary.</strong>
      </p>
      
      <br>
      <p><strong>Client Signature:</strong> ______________________ <strong>Date:</strong> ________</p>
      
      <br><br>
      <h3 style="background-color: #f9f9f9; padding: 10px;">FOR TRAINER USE:</h3>
      <p><strong>Form Completed:</strong> ________________________________</p>
      <p><strong>Reviewed By:</strong> ___________________________________</p>
      <p><strong>Date:</strong> _________________________________________</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Emergency_Contact_Form.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadSessionNotes = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Training Session Notes</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">TRAINING SESSION NOTES</h1>
      
      <p><strong>Client:</strong> _________________________ <strong>Date:</strong> _______________</p>
      <p><strong>Session #:</strong> _________ <strong>Duration:</strong> _________ <strong>Type:</strong> __________</p>
      
      <h3 style="background-color: #fef3c7; padding: 10px;">WARM-UP (10 minutes):</h3>
      <p><strong>Activities:</strong> ____________________________________</p>
      <p>_______________________________________________</p>
      
      <h3 style="background-color: #dbeafe; padding: 10px;">MAIN WORKOUT:</h3>
      
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr style="background-color: #f8f8f8;">
          <th style="padding: 8px;">Exercise</th>
          <th style="padding: 8px;">Sets</th>
          <th style="padding: 8px;">Reps</th>
          <th style="padding: 8px;">Weight</th>
          <th style="padding: 8px;">Rest</th>
          <th style="padding: 8px;">Notes</th>
        </tr>
        <tr>
          <td style="padding: 8px;">___________________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">____________________________________</td>
        </tr>
        <tr>
          <td style="padding: 8px;">___________________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">____________________________________</td>
        </tr>
        <tr>
          <td style="padding: 8px;">___________________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">____________________________________</td>
        </tr>
        <tr>
          <td style="padding: 8px;">___________________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">____________________________________</td>
        </tr>
        <tr>
          <td style="padding: 8px;">___________________________________</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">_____</td>
          <td style="padding: 8px;">____________________________________</td>
        </tr>
      </table>
      
      <h3 style="background-color: #dcfce7; padding: 10px;">COOL DOWN (10 minutes):</h3>
      <p><strong>Activities:</strong> ____________________________________</p>
      <p>_______________________________________________</p>
      
      <h3 style="background-color: #fce7f3; padding: 10px;">CLIENT PERFORMANCE:</h3>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>Energy Level (1-10):</strong> ___________________________</td>
          <td style="padding: 8px;"><strong>Form Quality (1-10):</strong> ___________________________</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Effort Level (1-10):</strong> ___________________________</td>
          <td style="padding: 8px;"></td>
        </tr>
      </table>
      
      <h3>OBSERVATIONS:</h3>
      <p><strong>Strengths displayed:</strong> ___________________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Areas for improvement:</strong> _________________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Modifications made:</strong> ____________________________</p>
      <p>_______________________________________________</p>
      
      <h3 style="background-color: #e0f2fe; padding: 10px;">NEXT SESSION PLAN:</h3>
      <p><strong>Focus areas:</strong> ___________________________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Progressions to implement:</strong> ____________________</p>
      <p>_______________________________________________</p>
      <br>
      <p><strong>Equipment needed:</strong> ______________________________</p>
      <p>_______________________________________________</p>
      
      <br><br>
      <p><strong>TRAINER SIGNATURE:</strong> ______________________ <strong>DATE:</strong> ________</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Session_Notes_Template.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadTrainingTerms = () => {
    const content = `
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Training Terms and Conditions</title>
    </head>
    <body style="font-family: Arial, sans-serif; font-size: 12pt; line-height: 1.5;">
      
      <h1 style="text-align: center; margin-bottom: 30px;">TRAINING TERMS AND CONDITIONS</h1>
      
      <p><strong>CLIENT:</strong> ______________________________ <strong>DATE:</strong> ___________</p>
      <p><strong>TRAINER:</strong> _____________________________ </p>
      
      <h3 style="background-color: #dbeafe; padding: 10px; color: #1e40af;">BOOKING AND PAYMENT PROCESS:</h3>
      <ul>
        <li>All sessions are booked through the online platform</li>
        <li>Payment is processed automatically through the platform</li>
        <li>Session rates are set by the trainer and displayed during booking</li>
        <li>Platform handles all payment processing and scheduling</li>
      </ul>
      
      <h3 style="background-color: #dcfce7; padding: 10px; color: #15803d;">SESSION RATES:</h3>
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;" border="1">
        <tr>
          <td style="padding: 8px;"><strong>My current rate:</strong> $______ per session</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Session duration:</strong> ______ minutes</td>
        </tr>
        <tr>
          <td style="padding: 8px;"><strong>Travel fee (if applicable):</strong> $______</td>
        </tr>
      </table>
      
      <h3 style="background-color: #fef3c7; padding: 10px; color: #92400e;">CANCELLATION POLICY:</h3>
      <ul>
        <li>24-hour notice required for session cancellations</li>
        <li>Cancellations with less than 24 hours notice may result in charges</li>
        <li>No-shows will be charged the full session fee</li>
        <li>Emergency cancellations will be considered case-by-case</li>
        <li>Refunds for valid cancellations processed through the platform</li>
      </ul>
      
      <h3 style="background-color: #e0e7ff; padding: 10px; color: #3730a3;">SESSION EXPECTATIONS:</h3>
      <ul>
        <li>Client will be ready and available at scheduled time</li>
        <li>Appropriate workout space and basic equipment should be available</li>
        <li>Client is responsible for informing trainer of any health changes</li>
        <li>Sessions will be conducted in a professional and safe manner</li>
      </ul>
      
      <h3 style="background-color: #f3e8ff; padding: 10px; color: #7c3aed;">RESCHEDULING:</h3>
      <ul>
        <li>Rescheduling requests must be made through the platform</li>
        <li>Subject to trainer availability</li>
        <li>Multiple last-minute reschedules may result in booking restrictions</li>
      </ul>
      
      <h3 style="background-color: #fee2e2; padding: 10px; color: #dc2626;">HEALTH AND SAFETY:</h3>
      <ul>
        <li>Client confirms they are medically cleared for physical activity</li>
        <li>Client will inform trainer immediately of any discomfort or injury</li>
        <li>Trainer reserves the right to modify or stop session for safety reasons</li>
        <li>Emergency contact information must be provided and kept current</li>
      </ul>
      
      <h3>PROFESSIONAL BOUNDARIES:</h3>
      <ul>
        <li>Training sessions are professional services only</li>
        <li>Personal relationships outside of training are discouraged</li>
        <li>Communication should primarily occur through the platform</li>
      </ul>
      
      <h3>TERMINATION:</h3>
      <ul>
        <li>Either party may end the professional relationship at any time</li>
        <li>Future bookings can be cancelled through the platform</li>
        <li>No additional fees apply for ending the relationship</li>
      </ul>
      
      <h3 style="background-color: #f0f9ff; padding: 10px;">ADDITIONAL SERVICES:</h3>
      <p>Any services outside of platform bookings (meal planning, additional consultations, etc.) require separate agreement:</p>
      <br>
      <p><strong>Service:</strong> _______________________________________</p>
      <p><strong>Rate:</strong> _________________________________________</p>
      <p><strong>Terms:</strong> ________________________________________</p>
      
      <br><br>
      <div style="border: 2px solid #000; padding: 15px; background-color: #f9f9f9;">
        <h3 style="margin-top: 0;">AGREEMENT:</h3>
        <p>I understand that all bookings and payments are handled through the platform. I agree to these terms and conditions for our training relationship.</p>
      </div>
      
      <br><br>
      <table style="width: 100%; border-collapse: collapse;" border="1">
        <tr>
          <td style="padding: 10px;"><strong>CLIENT SIGNATURE:</strong> _________________________</td>
          <td style="padding: 10px;"><strong>DATE:</strong> _______</td>
        </tr>
        <tr>
          <td style="padding: 10px;"><strong>CLIENT PRINTED NAME:</strong> ______________________________</td>
          <td style="padding: 10px;"></td>
        </tr>
        <tr>
          <td style="padding: 10px;"><strong>TRAINER SIGNATURE:</strong> _______________________</td>
          <td style="padding: 10px;"><strong>DATE:</strong> _______</td>
        </tr>
        <tr>
          <td style="padding: 10px;"><strong>TRAINER PRINTED NAME:</strong> _____________________________</td>
          <td style="padding: 10px;"></td>
        </tr>
      </table>
      
      <br><br>
      <h3 style="background-color: #f9f9f9; padding: 10px;">PLATFORM BOOKING CONFIRMATION:</h3>
      <p><strong>Session Date:</strong> __________________________________</p>
      <p><strong>Session Time:</strong> __________________________________</p>
      <p><strong>Booking Reference:</strong> _____________________________</p>
      
    </body>
    </html>`;
    
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'application/msword' });
    element.href = URL.createObjectURL(file);
    element.download = 'Training_Terms_and_Conditions.doc';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Downloadable Resources</h3>
      <p className="text-gray-600 mb-8">Professional forms and templates to help you manage your training business</p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Client Consultation Form */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center mb-4">
            <div className="p-3 bg-blue-500 rounded-lg">
              <FileText className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <h4 className="font-semibold text-gray-900">Client Consultation Form</h4>
              <p className="text-sm text-gray-600">Initial client assessment</p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4">
            Comprehensive intake form covering health history, fitness goals, and current activity levels.
          </p>
          <ul className="text-xs text-gray-600 mb-4 space-y-1">
            <li>• Medical history questionnaire</li>
            <li>• Fitness goals assessment</li>
            <li>• Current activity evaluation</li>
            <li>• Emergency contact information</li>
          </ul>
          <button 
            onClick={downloadConsultationForm}
            className="w-full flex items-center justify-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            <Download className="h-4 w-4 mr-2" />
            Download Word Doc
          </button>
        </div>

        {/* Weekly Workout Plan Template */}
        <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center mb-4">
            <div className="p-3 bg-green-500 rounded-lg">
              <Calendar className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <h4 className="font-semibold text-gray-900">Weekly Workout Plan</h4>
              <p className="text-sm text-gray-600">Structured training template</p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4">
            Professional workout planning template with exercise tracking and progress notes.
          </p>
          <ul className="text-xs text-gray-600 mb-4 space-y-1">
            <li>• 7-day workout structure</li>
            <li>• Exercise sets & reps tracking</li>
            <li>• Progress monitoring section</li>
            <li>• Notes and modifications space</li>
          </ul>
          <button 
            onClick={downloadWorkoutPlan}
            className="w-full flex items-center justify-center px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
          >
            <Download className="h-4 w-4 mr-2" />
            Download Word Doc
          </button>
        </div>

        {/* Liability Waiver */}
        <div className="bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center mb-4">
            <div className="p-3 bg-red-500 rounded-lg">
              <Shield className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <h4 className="font-semibold text-gray-900">Liability Waiver</h4>
              <p className="text-sm text-gray-600">Legal protection document</p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4">
            Standard liability waiver to protect your training business from injury claims.
          </p>
          <ul className="text-xs text-gray-600 mb-4 space-y-1">
            <li>• Assumption of risk clause</li>
            <li>• Release of liability terms</li>
            <li>• Indemnification agreement</li>
            <li>• Medical clearance requirement</li>
          </ul>
          <div className="space-y-2">
            <button 
              onClick={downloadLiabilityWaiver}
              className="w-full flex items-center justify-center px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
            >
              <Download className="h-4 w-4 mr-2" />
              Download Word Doc
            </button>
            <p className="text-xs text-red-600 text-center">
              *Consult with legal counsel before use
            </p>
          </div>
        </div>

        {/* Nutrition Guidelines */}
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center mb-4">
            <div className="p-3 bg-orange-500 rounded-lg">
              <FileText className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <h4 className="font-semibold text-gray-900">Nutrition Guidelines</h4>
              <p className="text-sm text-gray-600">Basic nutrition education</p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4">
            General nutrition guidelines and healthy eating tips for your clients.
          </p>
          <ul className="text-xs text-gray-600 mb-4 space-y-1">
            <li>• Macronutrient basics</li>
            <li>• Portion control guidelines</li>
            <li>• Hydration recommendations</li>
            <li>• Meal timing suggestions</li>
          </ul>
          <button 
            onClick={downloadNutritionGuide}
            className="w-full flex items-center justify-center px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          >
            <Download className="h-4 w-4 mr-2" />
            Download Word Doc
          </button>
        </div>

        {/* Progress Tracking Sheet */}
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center mb-4">
            <div className="p-3 bg-purple-500 rounded-lg">
              <TrendingUp className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <h4 className="font-semibold text-gray-900">Progress Tracking Sheet</h4>
              <p className="text-sm text-gray-600">Client progress monitoring</p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4">
            Comprehensive progress tracking template for monitoring client improvements.
          </p>
          <ul className="text-xs text-gray-600 mb-4 space-y-1">
            <li>• Weight and measurements log</li>
            <li>• Strength progress tracking</li>
            <li>• Goal achievement markers</li>
            <li>• Photo progress section</li>
          </ul>
          <button 
            onClick={downloadProgressSheet}
            className="w-full flex items-center justify-center px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
          >
            <Download className="h-4 w-4 mr-2" />
            Download Word Doc
          </button>
        </div>

        {/* Emergency Contact Form */}
        <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200 rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center mb-4">
            <div className="p-3 bg-yellow-500 rounded-lg">
              <Bell className="h-6 w-6 text-white" />
            </div>
            <div className="ml-4">
              <h4 className="font-semibold text-gray-900">Emergency Contact Form</h4>
              <p className="text-sm text-gray-600">Safety information sheet</p>
            </div>
          </div>
          <p className="text-sm text-gray-700 mb-4">
            Essential emergency contact and medical information for client safety.
          </p>
          <ul className="text-xs text-gray-600 mb-4 space-y-1">
            <li>• Primary emergency contact</li>
            <li>• Medical conditions & allergies</li>
            <li>• Insurance information</li>
            <li>• Preferred hospital/clinic</li>
          </ul>
          <button 
            onClick={downloadEmergencyForm}
            className="w-full flex items-center justify-center px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors"
          >
            <Download className="h-4 w-4 mr-2" />
            Download Word Doc
          </button>
        </div>
      </div>

      {/* Additional Resources Section */}
      <div className="mt-12 bg-gray-50 border border-gray-200 rounded-lg p-6">
        <h4 className="font-semibold text-gray-900 mb-4">Additional Business Resources</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center space-x-3 p-3 bg-white rounded-lg">
            <FileText className="h-8 w-8 text-gray-400" />
            <div>
              <h5 className="font-medium text-gray-900">Session Notes Template</h5>
              <p className="text-sm text-gray-600">Track client sessions and progress</p>
            </div>
            <button 
              onClick={downloadSessionNotes}
              className="ml-auto text-blue-500 hover:text-blue-700 font-medium"
            >
              Download Doc
            </button>
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-white rounded-lg">
            <DollarSign className="h-8 w-8 text-gray-400" />
            <div>
              <h5 className="font-medium text-gray-900">Training Terms & Conditions</h5>
              <p className="text-sm text-gray-600">Platform booking terms and expectations</p>
            </div>
            <button 
              onClick={downloadTrainingTerms}
              className="ml-auto text-blue-500 hover:text-blue-700 font-medium"
            >
              Download Doc
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerResourcesManager;